import { render } from "./Pulmonology.vue?vue&type=template&id=da97c796"
import script from "./Pulmonology.vue?vue&type=script&lang=ts"
export * from "./Pulmonology.vue?vue&type=script&lang=ts"
script.render = render

export default script